export const CRYPTO_CLARIFIED = 'Crypto Clarified';
export const THE_COMMODITY_EXCHANGE = 'The Commodity Exchange';
export const THE_NEXT_BIG_THING = 'The Next big thing';
